import { createContext, useContext } from "react";

/**
 * Whether a document page is live in a reader's browser (VIZ-3).
 *
 * The print route and the standalone bundle render the same document
 * components with `chrome` off — no export footer, no swap menu. But they
 * are not the same reader: a PDF is paper, and the HTML file and the embed
 * are open in a browser, where a chart's filter control still works. The
 * standalone bundle says so with this context; the print route never does,
 * so a printed chart shows its default and names the rest.
 */
export const InteractiveDocument = createContext(false);

export function useInteractiveDocument(): boolean {
  return useContext(InteractiveDocument);
}
